import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ConsolidatedByPlateService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

   timeReportConsolidate(imeis, dateIni, dateFin, rfidOnly, drivers): Promise<any> {
    console.log('service consolidate')
    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/timeReportConsolidate';

    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      rfid_only : rfidOnly,
      drivers:drivers
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        console.log('dataaaaaaaaaaaaaaaaaa : ', response)
        return response;
      });
  }

  consolidateReport(imeis, dateIni, dateFin, rfidOnly, drivers): Promise<any> {
    console.log('service consolidate')
    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/consolidateReport';

    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      rfid_only : rfidOnly,
      drivers:drivers
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  liquidationReport(imeis, dateIni, dateFin, rfidOnly, drivers): Promise<any> {
    console.log('service consolidate')
    dateFin = dateFin.toString().replace('T', ' ')
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/liquidationReport';

    var data = {
      imeis : imeis,
      dateIni : dateIni,
      dateFin : dateFin,
      user_account : this.commonService.getUserName(),
      rfid_only : rfidOnly,
      drivers:drivers
    }

    return this.http.post(url, data, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
}




// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/consolidated-by-plate.service.ts